export default interface PartnerTax {
    id: number;
    name: string;
}

export const partnerTaxDisplayDefaultProps: PartnerTax = {
    id: 0,
    name: ''
}